import { render, staticRenderFns } from "./ImageRepairView.vue?vue&type=template&id=74ecb9a8&"
import script from "./ImageRepairView.vue?vue&type=script&lang=js&"
export * from "./ImageRepairView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports